<div class="white-bg-overlay">&nbsp;</div>
<section class="left-nav-wrapper scroll-container">
  <div class="d-flex">
    <div class="me-auto">
      <h1>People Search</h1>
    </div>
  </div>
  <input
    id="search-input"
    class="form-control"
    placeholder="Search People..."
    [(ngModel)]="searchQuery"
    (keyup)="search()"
    autofocus
    autocomplete="off" />
  <div *ngIf="searchQuery.length < minSearchLength">
    <small>Enter at least {{ minSearchLength }} characters</small>
  </div>
  <div *ngIf="searchQuery.length >= minSearchLength && (!people || people.length === 0)">
    <em>No results found</em>
  </div>
  <div *ngIf="people && people.length > 0">
    <table class="table table-border">
      <thead>
        <tr>
          <th style="width: 50px"></th>
          <th>Name</th>
          <th>Id</th>
          <th>Date Hired</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let person of people">
          <td><i class="far fa-3x fa-user-circle"></i></td>
          <td>
            <a routerLink="/client/{{ clientCode }}/person/{{ person.Id }}">
              <strong>
                {{ person.LastName }}<span *ngIf="person.FirstName">, {{ person.FirstName }}</span>
              </strong>
            </a>
          </td>
          <td>{{ person.EmployeeId }}</td>
          <td>{{ person.HireDate | date: 'MM/dd/yyyy' }}</td>
        </tr>
      </tbody>
    </table>
    <lib-pagination [pagination]="pagination" (pageChanged)="loadPage($event)"></lib-pagination>
  </div>
</section>
